<template>
  <header :class="{ scrolled: isScrolled }">
    <div class="logo">
      <div class="logo-icon">
        <img src="../assets/PR_logo.png" alt="DiOrion Logo">
      </div>
      <div class="logo-text">DiOrion</div>
    </div>
    <div class="header-user-section">
      <!-- <span class="username" v-if="username">{{ username }}</span> -->
      <span class="username" v-if="username">{{ username }}</span>
      <button class="logout-btn" @click="handleLogout">
        Logout
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    username: {
      type: String,
      default: '' // 提供一个默认值
    }
  },
  data() {
    return {
      isScrolled: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    // 触发登出事件，通知父组件
    handleLogout() {
      this.$emit('logout');
    }
  }
};
</script>

<style scoped>

.header-user-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.username {
  color: #e6f1ff; /* 浅色文字，匹配标题色 */
  font-size: 1rem;
  font-weight: 500;
}

.logout-btn {
  background: rgba(100, 255, 218, 0.1); /* 半透明背景 */
  color: #64ffda; /* 主题色 */
  border: 1px solid #64ffda;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background: rgba(100, 255, 218, 0.2);
  color: #4cc9aa; /* hover深色 */
}
</style>